import React, { FC } from 'react';
import { L, TIMEZONES } from 'harmony-language';
import { Select } from './select';
import { Timezone } from 'harmony-constants';

interface SelectTimezoneProps {
    timezone: Timezone | null;
    onChange: (t: Timezone) => void;
}

export const SelectTimezone: FC<SelectTimezoneProps> = (props) => {
    const { timezone, onChange } = props;

    const menuItems = TIMEZONES.map(tz => ({ id: tz, value: tz, label: tz.replace('_', ' ') }));
    const item = menuItems.find(x => x.value === timezone);

    return (
        <Select
            label={L.selectTimezone()}
            list={menuItems}
            item={item}
            onChange={(v) => onChange(v.value)}/>
    );
};
